export default __webpack_public_path__ + "static/media/xprtlogo.8187448e.png";